import { transformDateToLocalDateString, useTranslate } from "helpers";
import { VehicleSpecificationProps } from "../types";

const VehicleWarranty: React.FC<VehicleSpecificationProps> = ({ fleetVehicleDetail }) => {
    const { t } = useTranslate();

    return (
        <div className="border-b border-slate-200 pt-4 px-4">
            <div className="text-sm font-bold text-slate-600 mb-3">
                {t("admin.fleet.vehicle.detail.info.warranty")}
            </div>
            <div className="grid grid-cols-4 gap-3 mb-4">
                <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                    <div className="text-sm text-slate-600">
                        {t("admin.fleet.vehicle.detail.info.warrantymileagelimit")}
                    </div>
                    <div className="text-md font-medium text-slate-800 truncate">
                        {fleetVehicleDetail.warrantyMileageLimit && (`${fleetVehicleDetail.warrantyMileageLimit} km`)}
                    </div>
                </div>
                <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                    <div className="text-sm text-slate-600">
                        {t("admin.fleet.vehicle.detail.info.warrantyexpirationdate")}
                    </div>
                    <div className="text-md font-medium text-slate-800 truncate">
                        {transformDateToLocalDateString(fleetVehicleDetail.warrantyExpirationDate)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VehicleWarranty;
